import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ServicesPage() {
  const services = [
    {
      number: '01',
      icon: 'ri-graduation-cap-fill',
      title: 'Admission Universitaire',
      description: 'Un accompagnement complet pour maximiser vos chances d\'admission dans les meilleures universités.',
      features: [
        'Analyse approfondie de votre profil académique et professionnel',
        'Sélection des établissements adaptés à vos objectifs',
        'Constitution complète des dossiers d\'admission',
        'Optimisation de votre CV et lettre de motivation',
        'Dépôt et suivi rigoureux de vos candidatures',
        'Préparation intensive aux entretiens d\'admission'
      ],
      color: 'bg-blue-500'
    },
    {
      number: '02',
      icon: 'ri-passport-fill',
      title: 'Visa & Immigration',
      description: 'Expertise complète pour naviguer les procédures complexes de visa et d\'immigration.',
      features: [
        'Montage complet du dossier de visa',
        'Préparation administrative détaillée',
        'Coaching personnalisé pour l\'entretien visa',
        'Prise de rendez-vous auprès des ambassades',
        'Veille réglementaire sur les exigences',
        'Assistance jusqu\'à l\'obtention du visa'
      ],
      color: 'bg-green-500'
    },
    {
      number: '03',
      icon: 'ri-compass-3-fill',
      title: 'Orientation Pré-Départ',
      description: 'Préparez-vous sereinement à votre nouvelle vie étudiante à l\'étranger.',
      features: [
        'Sessions d\'information sur la vie étudiante',
        'Conseils pour trouver un logement adapté',
        'Planification budgétaire et gestion financière',
        'Préparation à l\'adaptation culturelle',
        'Formation aux méthodes académiques locales',
        'Guide des démarches administratives à l\'arrivée'
      ],
      color: 'bg-purple-500'
    },
    {
      number: '04',
      icon: 'ri-translate-2',
      title: 'Cours & Certifications Linguistiques',
      description: 'Programmes de formation linguistique adaptés à vos besoins et objectifs académiques.',
      features: [
        'Préparation au DELF/DALF (français)',
        'Formation TCF/TEF pour le Canada',
        'Cours de préparation TOEFL',
        'Formation intensive IELTS',
        'Cours adaptés à votre niveau actuel',
        'Suivi personnalisé jusqu\'à la certification'
      ],
      color: 'bg-orange-500'
    },
    {
      number: '05',
      icon: 'ri-money-dollar-circle-fill',
      title: 'Aide aux Bourses',
      description: 'Maximisez vos chances d\'obtenir un financement pour vos études à l\'étranger.',
      features: [
        'Identification des opportunités de bourses',
        'Montage professionnel des candidatures',
        'Conseils financiers personnalisés',
        'Élaboration d\'un plan budgétaire réaliste',
        'Recherche de sources de financement alternatives',
        'Suivi des dossiers de demande de bourses'
      ],
      color: 'bg-yellow-500'
    },
    {
      number: '06',
      icon: 'ri-customer-service-2-fill',
      title: 'Accompagnement Continu',
      description: 'Un soutien permanent même après votre installation dans le pays d\'accueil.',
      features: [
        'Assistance administrative après installation',
        'Soutien académique en cas de difficulté',
        'Aide au renouvellement des démarches',
        'Conseil pour les stages et emplois étudiants',
        'Support pour l\'intégration sociale',
        'Disponibilité permanente de nos conseillers'
      ],
      color: 'bg-red-500'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="bg-gradient-to-r from-[#003D82] to-[#0052AD] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Nos Services</h1>
          <div className="w-24 h-1 bg-[#FF6B35] mb-6"></div>
          <p className="text-xl max-w-4xl leading-relaxed text-white/90">
            Un accompagnement complet et professionnel à chaque étape de votre projet d'études à l'étranger. De l'admission universitaire jusqu'à votre installation, nous sommes à vos côtés.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {services.map((service, index) => (
              <div 
                key={index}
                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
              >
                <div className="lg:w-1/2">
                  <div className="relative">
                    <img 
                      src={`https://public.readdy.ai/ai/img_res/396b0366f914e7fa985c88217fc2be20.jpg$%7Bservice.title.toLowerCase%28%29%7D%20international%20students%20university%20campus%20modern%20office%20bright%20atmosphere%20educational%20guidance%20professional%20setting%20clean%20background%20simple%20elegant&width=800&height=600&seq=service-${index + 1}&orientation=landscape`}
                      alt={`${service.title} - EduGlobe Campus`}
                      title={service.title}
                      className="w-full h-[400px] object-cover rounded-2xl shadow-xl"
                    />
                    <div className={`absolute -top-6 -left-6 w-20 h-20 ${service.color} rounded-2xl flex items-center justify-center text-white text-3xl font-bold shadow-lg`}>
                      {service.number}
                    </div>
                  </div>
                </div>

                <div className="lg:w-1/2">
                  <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mb-6">
                    <i className={`${service.icon} text-4xl text-[#FF6B35]`}></i>
                  </div>
                  <h2 className="text-3xl font-bold text-[#003D82] mb-4">{service.title}</h2>
                  <p className="text-lg text-gray-700 mb-6 leading-relaxed">{service.description}</p>
                  
                  <ul className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <i className="ri-checkbox-circle-fill text-[#FF6B35] text-xl mr-3 mt-1 flex-shrink-0"></i>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-[#003D82] mb-6">Prêt à commencer votre parcours ?</h2>
          <p className="text-xl text-gray-700 mb-8">
            Nos experts sont là pour vous accompagner à chaque étape de votre projet d'études à l'étranger.
          </p>
          <button
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-[#FF6B35] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#FF6B35]/90 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center"
          >
            <i className="ri-calendar-check-fill mr-3 text-2xl"></i>
            Réserver une consultation gratuite
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
